<!-- Petite Bannière -->
<section id="banner" class="for-contact" *ngIf="showBanner">
  <div class="banner-img-wrapper flexible">
    <img src="assets/imgs/contact.png" alt="Nous contacter image de background" class="width-100">
  </div>
</section>

<!-- Contact content -->
<section id="contact-content" style="margin-bottom: 100px">
  <div class="flexible flex-just-center">
    <div class="">
      <div class="container rmp override-container">
        <header class="flexible no-bg">
          <h5 class="inline-block width-100 text-center">
            <i class="fa fa-phone"></i>
            {{'front_contact.Contact'| translate}}
          </h5>
        </header>
        <div class="alert alert-danger" role="alert" *ngIf="errors.length">
          <b> {{'front_contact.errors'| translate}} :</b>
          <ul>
            <li *ngFor="let error of errors">{{error}}</li>
          </ul>
          {{ errorMsg }}
        </div>
        <form  *ngIf="!done"  (ngSubmit)="onSubmit(contactForm.valid)"  #contactForm="ngForm">
        <div class="table-wrapper">
          <div class="width-100 table">
            <div class="table-row flexible width-100 border-top" [ngClass]="{'has-danger': last_name.errors && (last_name.dirty ||last_name.touched || errors.length)}">
              <div class="flexible width-100">
                <div class="column flexible fixed-title text-left no-border-right"><label for="last_name" class="inline-block width-100">{{'front_contact.firstname'| translate}} </label></div>
                <div class="column flexible title text-left width-100 rmp">
                  <input type="text" name="last_name" #last_name="ngModel" value="{{contact.last_name}}" required id="last_name" placeholder="{{'front_contact.your_firstname'| translate}}" [(ngModel)]="contact.last_name"  class="width-100 height-100 text-left input-in-table">
                </div>
              </div>
            </div>
            <div class="table-row flexible width-100" [ngClass]="{'has-danger': first_name.errors && (first_name.dirty ||first_name.touched || errors.length)}">
              <div class="flexible width-100">
                <div class="column flexible fixed-title text-left no-border-right"><label for="first_name" class="inline-block width-100">{{'front_contact.lastname'| translate}}</label></div>
                <div class="column flexible title text-left width-100 rmp">
                  <input type="text" name="first_name" id="first_name" required placeholder="{{'front_contact.your_lastname'| translate}}"  #first_name="ngModel" [(ngModel)]="contact.first_name" value="" class="width-100 height-100 text-left input-in-table">
                </div>
              </div>
            </div>
            <div class="table-row flexible width-100" [ngClass]="{'has-danger': email.errors && (email.dirty ||email.touched || errors.length)}">
              <div class="flexible width-100">
                <div class="column flexible fixed-title text-left no-border-right"><label for="email" class="inline-block width-100">{{'front_contact.email'| translate}}</label></div>
                <div class="column flexible title text-left no-border width-100 rmp">
                  <input type="email" name="email" id="email"  value="" required  #email="ngModel" placeholder="{{'front_contact.your_email'| translate}}" [(ngModel)]="contact.email" class="width-100 height-100 text-left input-in-table">
                </div>
              </div>
            </div>
            <div class="table-row flexible width-100" [ngClass]="{'has-danger': (contact.destinataire == -1) && (destinataire.touched || errors.length)}" >
              <div class="flexible width-100">
                <div class="column flexible fixed-title text-left no-border-right"><label for="destinataire" class="inline-block width-100">{{'front_contact.recipient'| translate}}</label></div>
                <div class="column flexible title text-left width-100 rmp no-border">
                  <select [(ngModel)]="contact.destinataire" #destinataire="ngModel"  name="destinataire" id="destinataire" class="width-100 height-100 text-left input-in-table">
                    <option [value]=-1>{{'front_contact.choose'| translate}}</option>
                    <option [value]="Presse / Marketing">{{'front_contact.press_'| translate}}</option>
                    <option [value]="Service_Technique">{{'front_contact.service_'| translate}}</option>
                    <option [value]="SAV">{{'front_contact.sav'| translate}}</option>
                  </select>
                 <!-- <i class="fa fa-angle-down opacity-50" id="ajust-icon"></i>-->
                </div>
              </div>
            </div>
            <div class="table-row width-100" [ngClass]="{'has-danger': message.errors && (message.dirty ||message.touched || errors.length)}">
              <div class=" width-100">
                <div class="column  fixed-title text-left no-border-right "><label for="message" class="inline-block width-100">{{'front_contact.your_message'| translate}}</label></div>
                <div class="column  title text-left width-100 rmp contain-textarea {{textAreaHasHeigh155?'text-area-heigh':''}}" >
                  <textarea type="text" class="width-100 height-100 text-left input-in-table form-control"  required #message="ngModel" [(ngModel)]="contact.message" id="message" rows="10" name="message"></textarea>
                </div>
              </div>
            </div>
          </div>
        </div>
          <div class="" style="text-align: center">
            <span *ngIf="pendingRequest"  class="bold" style="display: block">{{'front_contact.processings'| translate}}</span>
          <button type="submit"  class="btn btn-primary btn-lg pull-center" >{{'front_contact.send'| translate}}</button>
          </div>
        </form>
        <div class="text-center" *ngIf="done">
          <div class="inline-block">
            <i class="fa fa-check check text-green"></i>
            <h5 class="text-uppercase" >{{'front_contact.your_text_has_been_sent'| translate}}</h5>
          </div>
        </div>

      </div>
    </div>
  </div>
</section>
